import type { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'
import { ProjectName } from '@previo/codebooks'
import { useReturnUrlLocalStore } from '~/store/redirect'

const redirectStore = useReturnUrlLocalStore()

const withFragment = (returnUrl: null | string, fragment: string): null | string => {
  if (returnUrl === null || fragment === '' || returnUrl.includes('#')) {
    return returnUrl
  }

  return returnUrl + fragment
}

const saveProjectAndReturnPath = async (
  to: RouteLocationNormalized,
  from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const projectName = to.params.project as string
  // browsers never send the fragment, so the server built returnUrl misses it
  const returnUrl = withFragment((to.query.returnUrl as string) || null, to.hash)
  let project: ProjectName

  if (Object.values(ProjectName).includes(projectName as ProjectName)) {
    project = projectName as ProjectName
  } else {
    // Set default project PMS
    project = ProjectName.PMS
  }

  redirectStore.value = { project: project, returnUrl: returnUrl }

  return next()
}

export default saveProjectAndReturnPath
